import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {ApiService} from "../../core/api/api.service";

@Component({
    selector: 'bergh-percentage-tab',
    templateUrl: './percentage-tab.component.html',
    styleUrls: ['./percentage-tab.component.scss'],
    standalone: false
})
export class PercentageTabComponent implements OnInit {
  public editPercentageForm: UntypedFormGroup;
  projectId: string;
  costDetails:any;
  loading:boolean = false;
  @Input() savePercentageEvent: boolean;
  @Output() savePercentageEventStatus: EventEmitter<boolean> = new EventEmitter()
  constructor(
    private formFB: UntypedFormBuilder,
    private _api: ApiService,
    private _toastr: ToastrService,
    private _route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.projectId = this._route.snapshot.paramMap.get('id');
    this.getExistingPercentages();
  }
  ngOnChanges(): void{
    if(this.savePercentageEvent){
      this.savePercentages()
    }
  }
  loadEditPercentageForm(details:any){
    this.editPercentageForm = this.formFB.group({
      risk: [details.invoiceRiskPercentage, Validators.required],
      profit: [details.invoiceProfitPercentage, Validators.required]
    })
  }

  savePercentages(){
    const payLoad= {
      invoiceProfitPercentage: this.editPercentageForm.get('profit').value,
      invoiceRiskPercentage: this.editPercentageForm.get('risk').value
    }
    this._api.request('updateCostPercentages', payLoad,`${this.projectId}/cost-management/percentages`).subscribe((result) => {
      this._toastr.success('Succesvol','Success');
    },(error)=>{
      this._toastr.error(error.message,'Error');
    });
    this.savePercentageEventStatus.emit(false);
  }
getExistingPercentages(){
  this.loading = true;
  this._api.request('getProjectCostDetails', '',`${this.projectId}/cost-management/`).subscribe((result) => {
    this.costDetails = result;
    this.loadEditPercentageForm(this.costDetails);
});
}

}
